import React from 'react';
import { GRAY_BACKGROUND, GRAY_USC, PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { LANGUAGES } from '~/Constants/Languages.constants';
import { AccessList, useHasAccess } from '~/Hooks';
import { FormControl, MenuItem, Select } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { useLanguageSelector } from './useLanguageSelector';

const useStyles = makeStyles((theme) => ({
  formControlRoot: {
    border: `1px solid ${GRAY_USC}`,
    borderRadius: '4px',
  },
  simpleFormControlRoot: {
    border: `none`,
  },
  selectRoot: {
    border: 0,
    fontSize: 12,
    color: GRAY_BACKGROUND,
    fontWeight: 'bold',
    height: 28,
  },
  simpleSelectRoot: {
    border: 0,
    fontSize: 12,
    fontWeight: 'bold',
    height: 28,
  },
  select: {
    padding: theme.spacing(),
  },
  selectIcon: {
    color: PRIMARY_BLUE,
  },
}));

export const LanguageSelector = ({ simple = false }) => {
  const { classes } = useStyles();
  const { hasAccess } = useHasAccess();
  const { currentLanguage, onLanguageChange } = useLanguageSelector();
  return (
    <FormControl
      classes={{ root: simple ? classes.simpleFormControlRoot : classes.formControlRoot }}
    >
      <Select
        classes={{ select: classes.select, icon: classes.selectIcon }}
        disableUnderline
        onChange={onLanguageChange}
        value={currentLanguage}
        newDesign
        className={simple ? classes.simpleSelectRoot : classes.selectRoot}
      >
        {LANGUAGES.map((item, index) => (
          <MenuItem key={index} value={item}>
            {item.toUpperCase()}
          </MenuItem>
        ))}
        {hasAccess(AccessList.TEXT_AS_KEYS) && <MenuItem value="keys">Keys</MenuItem>}
      </Select>
    </FormControl>
  );
};
